import axios from 'axios'
import moment from 'moment'
import { URL } from '../../../env'

const SORT_COLUMNS = {
  syndication_agreement_date: 'deal_syndications.syndication_agreement_date',
  syndication_status: 'deal_syndications.syndication_status',
  syndication_company_name: 'deal_syndications.syndication_company_name',
  contract_MID: 'deal_syndications.contract_MID',
  syndication_participation_percent: 'deal_syndications.syndication_participation_percent',
  syndication_total_participation_amt: 'deal_syndications.syndication_total_participation_amt',
  syndication_part_rtr: 'deal_syndications.syndication_part_rtr',
  anticipated_return_percent: 'anticipated_return_percent',
  syndication_balance: 'deal_syndications.syndication_balance',
  paid_percentage: 'paid_percentage',
  last_cleared_payment_date: 'deal_syndications.last_cleared_payment_date',
  collected_payment: 'balances_tbl.collected_payment',
  net_profit: 'net_profit',
  totalPayouts: 'totalPayouts',
  anticipatedPercent: 'anticipatedPercent',
}

const STATUS_COLORS = {
  Active: 'success',
  Complete: 'primary',
  'Complete with discount': 'info',
  Pending: 'warning',
  Collection: 'error',
  Default: 'error',
  'Write-off': 'error',
  Cancelled: 'error',
}

export default {
  data: () => ({
    processBar: false,
    excelBtnLoader: false,
    dealSyndication_payouts: [],
    tableData: {
      syndication_id: localStorage.getItem('syndication_id'),
      page: 1,
      length: 25,
      search: '',
      column: { name: 'Latest agreement date', value: { column: 'deal_syndications.syndication_agreement_date', sortBy: 'DESC' } },
      filter: {
        syndication_status: 'All Status',
        syndication_agreement_date: 'All M/Y',
      },
      excel_origin_start_date: null,
      excel_origin_end_date: null,
    },
    pages: 0,
    pagination: { sortBy: 'syndication_agreement_date', descending: true, rowsPerPage: -1 },
    deal_payouts: [],
    statuses: [],
    agreement_dates: [],
  }),
  mounted() {
    this.getData()
    this.getStatuses()
  },
  methods: {
    onPagination(pagination) {
      this.pagination = pagination
      const sortBy = pagination.descending ? 'DESC' : 'ASC'
      this.tableData.column = {
        column: SORT_COLUMNS[pagination.sortBy] || 'deal_syndications.syndication_agreement_date',
        sortBy,
        name: pagination.sortBy || 'Lowest net pay',
        value: { column: SORT_COLUMNS[pagination.sortBy] || this.sortValueFallback, sortBy },
      }
      this.tableData.page = 1
      this.getData()
    },
    async getData() {
      this.tableData.excel_origin_start_date = null
      this.tableData.excel_origin_end_date = null
      this.processBar = true
      await axios
        .post(`${URL}/api/payouts/get_dealsyndication_payouts`, this.tableData)
        .then(res => {
          this.processBar = false
          this.dealSyndication_payouts = res.data.deal_syndication_data.data
          this.tableData.page = Math.ceil(res.data.deal_syndication_data.to / this.tableData.length)
          this.pages = Math.ceil(res.data.deal_syndication_data.total / this.tableData.length)
        })
        .catch(() => {
          this.processBar = false
        })
    },
    getStatuses() {
      this.tableData.excel_origin_start_date = null
      this.tableData.excel_origin_end_date = null
      axios.get(`${URL}/api/payouts/get_dealsyndication_aggrementDate_statuses/` + this.tableData.syndication_id).then(res => {
        this.statuses = res.data.statuses
        this.statuses.unshift({ syndication_status: 'All Status' })
        this.agreement_dates = res.data.agreement_dates
        this.agreement_dates.unshift({ syndication_agreement_date: 'All M/Y' })
      })
    },
    next(page) {
      this.tableData.page = page
      this.getData()
    },
    toggleRow(props) {
      props.expanded = !props.expanded
      if (props.expanded) {
        axios
          .post(`${URL}/api/payouts/deal_payouts`, { syndication_id: props.item.syndication_id, contract_MID: props.item.contract_MID })
          .then(res => {
            this.deal_payouts = res.data
          })
      } else {
        this.deal_payouts = []
      }
    },
    async exportReport() {
      const file = this.exportFileName()
      this.excelBtnLoader = true
      await axios({
        url: `${URL}/api/payouts/export_syndicated_deals`,
        method: 'POST',
        responseType: 'blob',
        data: this.exportType ? { ...this.tableData, type: this.exportType } : this.tableData,
      })
        .then(response => {
          this.excelBtnLoader = false
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.setAttribute('download', file)
          document.body.appendChild(link)
          link.click()
        })
        .catch(() => {
          this.excelBtnLoader = false
        })
    },
    redirectFcs(deal_unique_id) {
      const route = this.$router.resolve({ name: 'V2Fcs', params: { unique_id: deal_unique_id } })
      window.open(route.href, '_blank')
    },
    isExcludedBalance(status) {
      return status == 'Write-off' || status == 'Complete with discount'
    },
    statusColor(status) {
      return STATUS_COLORS[status] || 'grey'
    },
    upto2decimal(val) {
      return val ? parseFloat(val).toFixed(2) : 0
    },
    getPercentage(val) {
      return val ? (val * 100).toFixed(2) : 0
    },
    getPercentagePaid(netProfit, participationAmt) {
      let net_profit = netProfit ? parseFloat(netProfit) : 0
      if (net_profit < 0) return 0
      let participation_amt = participationAmt ? parseFloat(participationAmt) : 0
      return participation_amt == 0 ? 0 : ((net_profit / participation_amt) * 100).toFixed(2)
    },
    formatDate(date) {
      return date ? moment(date).format('MM/DD/YYYY') : ''
    },
  },
}
